import * as Types from '../../../__generated__/types.generated';

import { gql } from '@apollo/client';
import { HotspotBaseFragmentDoc } from './hotspot-base-fragment.generated';
import { DestinationOnHotspotFragmentDoc } from './hotspot-destination-fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HotspotQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type HotspotQuery = { __typename?: 'RootQueryType', hotspot?: { __typename?: 'Hotspot', id: string, x: number, y: number, text: string, textColor: string, bgColor: string, alwaysShowText: boolean, destinationType?: Types.NextInteractionType | null, value?: string | null, middleInteraction: { __typename?: 'MiddleInteraction', id: string, type: Types.MiddleInteractionType, question?: string | null, embed?: { __typename?: 'Embed', id: string, linkUrl: string, oembedResult?: any | null, status: Types.EmbedStatus, reason?: Types.EmbedFailureReason | null } | null }, nextPage?: { __typename?: 'InitiationItem', id: string, title: string, type: Types.InitiationItemType, order: number } | null } | null };


export const HotspotDocument = gql`
    query Hotspot($id: ID!) {
  hotspot(id: $id) {
    ...HotspotBase
    ...DestinationOnHotspot
  }
}
    ${HotspotBaseFragmentDoc}
${DestinationOnHotspotFragmentDoc}`;

/**
 * __useHotspotQuery__
 *
 * To run a query within a React component, call `useHotspotQuery` and pass it any options that fit your needs.
 * When your component renders, `useHotspotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHotspotQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHotspotQuery(baseOptions: Apollo.QueryHookOptions<HotspotQuery, HotspotQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HotspotQuery, HotspotQueryVariables>(HotspotDocument, options);
      }
export function useHotspotLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HotspotQuery, HotspotQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HotspotQuery, HotspotQueryVariables>(HotspotDocument, options);
        }
export type HotspotQueryHookResult = ReturnType<typeof useHotspotQuery>;
export type HotspotLazyQueryHookResult = ReturnType<typeof useHotspotLazyQuery>;
export type HotspotQueryResult = Apollo.QueryResult<HotspotQuery, HotspotQueryVariables>;
export function refetchHotspotQuery(variables: HotspotQueryVariables) {
      return { query: HotspotDocument, variables: variables }
    }